import { createAction } from '@ngrx/store';

export const keyboardFeatureKey = 'Keyboard';

const escapePressed = createAction(`[${keyboardFeatureKey}] Escape pressed`);

export const KeyboardActions = {
  escapePressed,
};
